import src from "IMAGE";
export default { src, width: 137, height: 39, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADcJDTk5CQ04QAsPPT0KDzs2CQ0zQgsQP08NE008Cg47ADkKDj9IDBFKRAwQRUYMEUVFCxBEPgoPO0sNEk5PDRNRNV0J1s4j2owAAAAASUVORK5CYII="};
